var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqTransmission = function SvgFaqTransmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-transmission_svg__a)",
    d: "M21.65 8.725V6.243c1.246-.373 2.153-1.507 2.153-2.866 0-1.655-1.349-3.003-3.003-3.003s-3.003 1.348-3.003 3.003c0 1.36.918 2.504 2.153 2.866v2.482c0 1.156-.986 2.096-2.187 2.096h-5.122V6.345s-.022-.068-.022-.113a2.994 2.994 0 0 0 2.164-2.867c0-1.654-1.348-3.002-3.003-3.002S8.777 1.71 8.777 3.365c0 1.371.93 2.527 2.199 2.878 0 .034-.023.068-.023.102v4.476h-6.89V6.345s-.01-.068-.022-.102a2.994 2.994 0 0 0 2.176-2.878A3.01 3.01 0 0 0 3.214.363 3.01 3.01 0 0 0 .21 3.365c0 1.371.93 2.516 2.176 2.878 0 .034-.023.068-.023.102v9.304h1.7v-3.14h6.889v3.14h1.7v-3.14h5.121c2.142 0 3.887-1.699 3.887-3.795zM1.888 3.365c0-.725.59-1.303 1.303-1.303.714 0 1.303.59 1.303 1.303a1.31 1.31 0 0 1-1.303 1.303 1.31 1.31 0 0 1-1.303-1.303m8.566 0c0-.725.59-1.303 1.303-1.303.714 0 1.304.59 1.304 1.303a1.31 1.31 0 0 1-1.303 1.303 1.31 1.31 0 0 1-1.304-1.303m9.032 0c0-.725.589-1.303 1.303-1.303.713 0 1.303.59 1.303 1.303a1.31 1.31 0 0 1-1.303 1.303 1.31 1.31 0 0 1-1.303-1.303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-transmission_svg__b)",
    d: "M20.8 17.632a3.01 3.01 0 0 0-3.003 3.003 3.01 3.01 0 0 0 3.003 3.003 3.01 3.01 0 0 0 3.003-3.003 3.01 3.01 0 0 0-3.003-3.003m0 4.317c-.725 0-1.303-.589-1.303-1.303s.589-1.303 1.303-1.303 1.303.59 1.303 1.303-.59 1.303-1.303 1.303",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-transmission_svg__c)",
    d: "M11.792 17.632a3.01 3.01 0 0 0-3.003 3.003 3.01 3.01 0 0 0 3.003 3.003 3.01 3.01 0 0 0 3.003-3.003 3.01 3.01 0 0 0-3.003-3.003m0 4.317c-.725 0-1.303-.589-1.303-1.303s.589-1.303 1.303-1.303 1.303.59 1.303 1.303-.59 1.303-1.303 1.303"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-transmission_svg__d)",
    d: "M3.202 17.632a3.01 3.01 0 0 0-3.003 3.003c0 1.654 1.349 3.003 3.003 3.003s3.003-1.349 3.003-3.003a3.01 3.01 0 0 0-3.003-3.003m0 4.317c-.725 0-1.303-.589-1.303-1.303s.59-1.303 1.303-1.303c.714 0 1.303.59 1.303 1.303s-.59 1.303-1.303 1.303"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-transmission_svg__a",
    x1: 12.007,
    x2: 12.007,
    y1: 15.649,
    y2: 0.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-transmission_svg__b",
    x1: 20.8,
    x2: 20.8,
    y1: 23.638,
    y2: 17.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-transmission_svg__c",
    x1: 11.792,
    x2: 11.792,
    y1: 23.638,
    y2: 17.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-transmission_svg__d",
    x1: 3.202,
    x2: 3.202,
    y1: 23.638,
    y2: 17.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqTransmission;